import React from 'react'
import Loader from 'react-loader-spinner'
import { Highlighter } from 'react-bootstrap-typeahead'
import PillComponent from '../../ui/PillComponent'

const SearchResultItem = ({ item, inputText }) => {
  const handleOnClick = (event, item) => {
    event.stopPropagation()
    const url = (() => {
      switch (item.type) {
        case 'Case':
          return `/cases/${item.id}/complaints`
        case 'Resident':
          return `/residents/${item.id}`
        case 'Facility':
          return `/facilities/${item.id}`
        case 'Perpetrator':
          return `/perpetrators/${item.id}`
        case 'Activity':
          return `/activities/${item.id}`
        case 'Incident':
          return `/incidents/${item.id}/notes`
        default:
          return '/'
      }
    })()

    window.location.pathname = url
  }

  const Row = ({ item, inputText, onClickCallback }) => {
    return (
      <div className='search-result-row p-4' onClick={event => onClickCallback(event, item)}>
        {item.type === 'Case' && <CaseOrIncident item={item} inputText={inputText} />}
        {item.type === 'Incident' && <CaseOrIncident item={item} inputText={inputText} />}
        {item.type === 'Resident' && <Person item={item} inputText={inputText} />}
        {item.type === 'Perpetrator' && <Person item={item} inputText={inputText} />}
        {item.type === 'Activity' && <Activity item={item} inputText={inputText} />}
        {item.type === 'Facility' && <Facility item={item} inputText={inputText} />}
      </div>
    )
  }

  const CaseOrIncident = ({ item, inputText }) => {
    const pillColor = item.status === 'Open' ? 'gold' : 'gray'
    return (
      <div id={`${item.type}-${item.id}`} className='row'>
        <div className='col-2 col-md-1'>
          <span className='text-grey'>{item.code}</span>
          <PillComponent color={pillColor} text={item.status} />
        </div>
        <div className='col-10 col-md-11 ps-6'>
          <div className='d-flex gap-2'>
            <i className='fa fa-user' />
            <span>
              <Highlighter search={inputText}>{item.resident}</Highlighter>
            </span>
            <div className='border-start ps-2'>
              <Highlighter search={inputText}>{item.title}</Highlighter>
            </div>
          </div>
          <div className='d-flex mt-2 gap-2'>
            <i className='fa fa-home my-auto omb-text-grey' />
            <span className='text-grey'>
              <Highlighter search={inputText}>{item.facility}</Highlighter>
            </span>
            {item.complainant && (
              <div className='d-flex gap-2'>
                <i className='fas fa-circle dot' />
                <span className='text-grey ms-2'>
                  <Highlighter search={inputText}>{item.complainant}</Highlighter>
                </span>
              </div>
            )}
            {item.perpetrators && (
              <div className='d-flex gap-2'>
                <i className='fas fa-circle dot' />
                <span className='text-grey ms-2'>
                  <div className='d-flex gap-2'>
                    <i className='fa fa-user omb-text-orange' />
                    <span>
                      <Highlighter search={inputText}>{item.perpetrators}</Highlighter>
                    </span>
                  </div>
                </span>
              </div>
            )}
            <i className='fas fa-circle dot ms-2' />
            <span className='text-grey ms-2'>{item.assignee}</span>
            <i className='fas fa-circle dot ms-2' />
            <span className='text-grey ms-2'>Opened: {item.open_date}</span>
          </div>
        </div>
      </div>
    )
  }

  const Activity = ({ item, inputText }) => {
    return (
      <div id={`Activity-${item.id}`} className='row'>
        <div className='col-2 col-md-1'>
          <span className='text-grey'>{item.code}</span>
        </div>
        <div className='col-10 col-md-11 ps-6'>
          <div className='d-flex gap-2'>
            {item.residents && (
              <div className='d-flex gap-2 pe-2 border-end'>
                <i className='fa fa-user' />
                <span>
                  <Highlighter search={inputText}>{item.residents}</Highlighter>
                </span>
              </div>
            )}
            <div>
              <Highlighter search={inputText}>{item.activity_type}</Highlighter>
            </div>
          </div>
          <div className='d-flex mt-2 gap-2'>
            {item.facility && (
              <div className='d-flex gap-2'>
                <i className='fa fa-home my-auto omb-text-grey' />
                <span className='text-grey'>
                  <Highlighter search={inputText}>{item.facility}</Highlighter>
                </span>
              </div>
            )}
            <i className='fas fa-circle dot ms-2' />
            <span className='text-grey ms-2'>{item.assignee}</span>
            <i className='fas fa-circle dot ms-2' />
            <span className='text-grey ms-2'>{item.interaction_on}</span>
          </div>
          <div className='mt-2 text-grey'>
            <Highlighter search={inputText}>{item.narrative}</Highlighter>
          </div>
        </div>
      </div>
    )
  }

  const Facility = ({ item, inputText }) => {
    return (
      <div id={`Facility-${item.id}`} className='row'>
        <div className='d-flex gap-2'>
          <span>
            <Highlighter search={inputText}>{item.name}</Highlighter>
          </span>

          {item.city && (
            <div className='d-flex gap-2 ms-4'>
              <i className='fa fa-map-marker my-auto omb-text-grey' />
              <span className='text-grey'>{item.city}</span>
            </div>
          )}
          <div className='d-flex gap-2'>
            <div className='d-flex gap-2'>
              <i className='fas fa-circle dot mx-4 omb-text-grey' />
              <span className='text-grey'>{item.facility_type}</span>
            </div>
          </div>
          <i className='fas fa-circle dot mx-4 omb-text-grey' />
          {item.facility_names.length > 1 && (
            <div className='text-grey'>
              <span
                className={
                  item.facility_names &&
                  item.facility_names.some(
                    name =>
                      name.toLowerCase().includes(inputText.toLowerCase()) &&
                      name.toLowerCase() !== item.name.toLowerCase()
                  )
                    ? 'mark'
                    : ''
                }
              >
                {`${item.facility_names_count} previous facility names`}
              </span>
            </div>
          )}
        </div>
      </div>
    )
  }

  const Person = ({ item, inputText }) => {
    return (
      <div id={`${item.type}-${item.id}`} className='row'>
        <div className='d-flex gap-6'>
          {item.type === 'Resident' ? <i className='fa fa-user' /> : <i className='fa fa-user omb-text-orange' />}
          <span>
            <Highlighter search={inputText}>{item.name}</Highlighter>
          </span>
          {item.birthday && (
            <div className='d-flex gap-2'>
              <i className='fa fa-calendar my-auto omb-text-grey' />
              <span>
                <Highlighter search={inputText}>{item.birthday}</Highlighter>
              </span>
            </div>
          )}
          {item.facility && (
            <div className='d-flex gap-2'>
              <i className='fas fa-circle dot me-4 omb-text-grey' />
              <i className='fa fa-home my-auto omb-text-grey' />
              <span>
                <Highlighter search={inputText}>{item.facility}</Highlighter>
              </span>
            </div>
          )}
          {item.phone && (
            <div className='d-flex gap-2'>
              <i className='fas fa-circle dot me-4 omb-text-grey' />
              <i className='fa fa-phone my-auto omb-text-grey' />
              <span>
                <Highlighter search={inputText}>{item.phone}</Highlighter>
              </span>
            </div>
          )}
        </div>
      </div>
    )
  }

  return <Row item={item} inputText={inputText} onClickCallback={handleOnClick} />
}

export default function SearchResults({ inputText, searchResults }) {
  if (!inputText) return null

  if (!searchResults || (searchResults && searchResults.loading)) {
    return (
      <div className='text-center omb-search-results position-absolute'>
        <Loader type='ThreeDots' color='#00BFFF' height={80} width={80} />
      </div>
    )
  }

  if (
    (searchResults.result && searchResults.result.error) ||
    !searchResults.result ||
    searchResults.result.length === 0
  ) {
    return (
      <div className='text-center omb-search-results position-absolute'>
        <p className='text-muted'>No results. Refine your search</p>
      </div>
    )
  }

  const customOrder = ['Facility', 'Resident', 'Perpetrator', 'Case', 'Incident', 'Activity']

  const groupedResults = searchResults.result.reduce((groups, item) => {
    const { type } = item
    if (!groups[type]) {
      groups[type] = []
    }
    groups[type].push(item)
    return groups
  }, {})

  const sortedGroupedResults = customOrder.reduce((sortedGroups, type) => {
    if (groupedResults[type]) {
      sortedGroups[type] = groupedResults[type]
    }
    return sortedGroups
  }, {})

  const groupTitle = type => {
    switch (type) {
      case 'Case':
        return 'Cases'
      case 'Incident':
        return 'Incidents'
      case 'Facility':
        return 'Facilities'
      case 'Resident':
        return 'Residents'
      case 'Perpetrator':
        return 'Perpetrators'
      case 'Activity':
        return 'Activities'
    }
  }

  return (
    <div className='omb-search-results position-absolute'>
      {Object.keys(sortedGroupedResults).map(type => (
        <div key={type}>
          <div className='border p-2 group-header'>{groupTitle(type)}</div>
          {sortedGroupedResults[type].map(item => (
            <SearchResultItem key={item.id} item={item} inputText={inputText} />
          ))}
        </div>
      ))}
    </div>
  )
}
